import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const OurOffice = () => {
   return (
      <section className="our-office pt-100 pb-100 mt-60">
         <div className="tw-container tw-mx-auto">
            <div className="section__title section__title-3 tw-text-center mb-45">
               <span>Visit Us</span>
               <h2>Our Office</h2>
            </div>

            <div className="our-office__inner">
               <div className="our-office__card">
                  <span className="our-office__badge">Headquarters</span>
                  <h3>Harsoft Solutions</h3>
                  <p>
                     Akshaya Heights, 2nd Floor, Plot Nos. 133(P), 134, 135 &amp; 136(P), Road No. 9,
                     Sai Aishwarya Layout Rd, Chitrapuri Colony, Khajaguda, Hyderabad, Telangana 500104.
                  </p>
                  <p><a href="tel:+919030350309">(+91) - 9030350309</a></p>
                  <a className="our-office__direction" href="https://www.google.com/maps/dir//Harsoft+Solutions,+2nd+Floor,+Akshaya+Heights,+Plot+Nos.+133(P),+134,+135+%26+136(P),+Road+No.+9,+Sai+Aishwarya+Layout+Rd,+Chitrapuri+Colony,+Khajaguda,+Hyderabad,+Telangana+500104/@17.4147503,78.3710126,1027m/data=!3m1!1e3!4m16!1m7!3m6!1s0x3bcb93445e4fa3e5:0x14cfe630957e1e47!2sHarsoft+Solutions!8m2!3d17.4147503!4d78.3710126!16s%2Fg%2F11m5_pyhtm!4m7!1m0!1m5!1m1!1s0x3bcb93445e4fa3e5:0x14cfe630957e1e47!2m2!1d78.3710394!2d17.4147471?entry=ttu&g_ep=EgoyMDI2MDgxMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
                     Get directions
                     <ArrowUpRight size={16} />
                  </a>
               </div>

               <div className="our-office__map">
                  <iframe title="Harsoft Solutions office location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4471.169544522878!2d78.3710126!3d17.414750299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93445e4fa3e5%3A0x14cfe630957e1e47!2sHarsoft%20Solutions!5e1!3m2!1sen!2sin!4v1786983977237!5m2!1sen!2sin"></iframe>
               </div>
            </div>
         </div>
      </section>
   );
};

export default OurOffice;
